var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73337 3.00002C4.60272 2.14806 5.77317 1.6736 6.99037 1.67975C8.20757 1.68589 9.37317 2.17215 10.2339 3.03285C11.0946 3.89356 11.5808 5.05915 11.587 6.27635C11.5931 7.49355 11.1187 8.664 10.2667 9.53336L7.82487 11.9752C7.60609 12.1939 7.3094 12.3168 7.00004 12.3168C6.69068 12.3168 6.39399 12.1939 6.1752 11.9752L3.73337 9.53336C2.86706 8.66695 2.38037 7.49191 2.38037 6.26669C2.38037 5.04147 2.86706 3.86643 3.73337 3.00002Z",
    strokeWidth: 1.16667,
    strokeLinejoin: "round",
    stroke: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.26562C8.75 7.23212 7.9665 8.01562 7 8.01562C6.0335 8.01562 5.25 7.23212 5.25 6.26562C5.25 5.29913 6.0335 4.51562 7 4.51562C7.9665 4.51562 8.75 5.29913 8.75 6.26562Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceLocationIcon);
export default __webpack_public_path__ + "static/media/dice-location-icon.cdfc9e94138b8ed78111fdcebf1a0c2c.svg";
export { ForwardRef as ReactComponent };